import api from "./api";

const inFlight = new Map();

function toIdKey(id) {
  const n = Number(id);
  return Number.isFinite(n) && n > 0 ? String(n) : null;
}

// Lista todos os sindicatos
// Endpoint: GET /api/sindicato/getAll
export const getSindicatos = () => api.get("/api/sindicato/getAll");

// Lista todos os sindicatos com dados de pagamento
// Endpoint: GET /api/sindicato/getAllPagamento
export const getSindicatosPagamento = () =>
  api.get("/api/sindicato/getAllPagamento");

// Busca os dados do sindicato do usuário logado
// Endpoint: GET /api/sindicato/getByLoggedUser
export const getSindicatoByLoggedUser = () =>
  api.get("/api/sindicato/getByLoggedUser");

// Busca um sindicato por ID com controle de requisições duplicadas em andamento
// Endpoint: GET /api/sindicato/getById/{id}
export const getSindicatoById = (id) => {
  const idKey = toIdKey(id);
  if (!idKey) {
    return Promise.reject(new Error("getSindicatoById: id inválido"));
  }

  const key = `getSindicatoById:${idKey}`;

  if (inFlight.has(key)) {
    return inFlight.get(key);
  }

  const promise = api.get(`/api/sindicato/getById/${idKey}`).finally(() => {
    inFlight.delete(key);
  });

  inFlight.set(key, promise);
  return promise;
};

// Atualiza os dados de um sindicato
// Endpoint: PUT /api/sindicato/update/{idSindicato}
export const updateSindicato = (data) => {
  return api.put(`/api/sindicato/update/${data.idSindicato}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const sindicatoService = {
  getSindicatos,
  getSindicatosPagamento,
  getSindicatoByLoggedUser,
  getSindicatoById,
  updateSindicato,
};

export default sindicatoService;
